import { render, staticRenderFns } from "./indexSwap.vue?vue&type=template&id=3f183a1a&scoped=true"
import script from "./indexSwap.vue?vue&type=script&lang=js"
export * from "./indexSwap.vue?vue&type=script&lang=js"
import style0 from "./indexSwap.vue?vue&type=style&index=0&id=3f183a1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_yhenekn6hnf4pbbtdhpnebbsqm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f183a1a",
  null
  
)

export default component.exports